export interface RoundelData {
  name: string
  imageUrl: string
  link: string
}

export const transformToRoundels = (data: any[] | undefined): RoundelData[] => {
  if (!data) return []

  return data.map((item) => ({
    name: item.label || item.name,
    imageUrl: item.imageUrl || item.roundel?.imageUrl,
    link: item.link || item.roundel?.link
  }))
}
